import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import FreeTextInput from "features/tradingTerminal/FreeText/FreeTextInput";
import Modal from "common/Modal/Modal";
import React from "react";
import useFreeText from "@shared/features/tradingTerminal/common/hooks/useFreeText";
import { displayResultMessage, openMessage } from "utils/misc";
import { FreeTextModalProps } from "@shared/features/tradingTerminal/common/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const FreeTextModal = ({ visible, closeModal }: FreeTextModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);
  const {
    onOk,
    isLoading,
    rawFreeText,
    setRawFreeText,
    isMobile,
    inputPlaceholder,
    helperTooltipData,
  } = useFreeText(closeModal, openMessage, displayResultMessage);

  return (
    <Modal
      onOk={onOk}
      open={visible}
      destroyOnHidden={true}
      title={
        <div style={{ display: "flex" }}>
          {t("free_text.title")}
          <HelperTooltip {...helperTooltipData} />
        </div>
      }
      okButtonProps={{
        loading: isLoading,
        disabled: !rawFreeText,
      }}
      onCancel={closeModal}
      styles={{
        body: { padding: isMobile ? 16 : 24 },
      }}
    >
      <FreeTextInput
        setFreeText={setRawFreeText}
        freeText={rawFreeText}
        placeholder={inputPlaceholder}
      />
    </Modal>
  );
};

export default FreeTextModal;
